import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { BasicProviderProps, DashboardContextType, NavigationBar, NavItemDataProps, DocumentationProps } from '../types';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppContext } from './AppContext';
import ErrorBoundary from '../components/error/ErrorBoundary';
import useDocumentTitle from '../hooks/useDocumentTitle';
import useAppDataControl from '../hooks/useAppDataControl';
import SplashScreen from '../components/containers/SplashScreen';
import { URLAPP } from '../config';
import useUserStorage from '../hooks/useUserStorage';

export const DashboardContext = createContext<DashboardContextType | null>(null);

let urlAppProperty: keyof typeof URLAPP
let urlAvaibles: string[] = []
for (urlAppProperty in URLAPP) {
    urlAvaibles.push(URLAPP[urlAppProperty])
}

export default function DashboardProvider({ children }: BasicProviderProps) {

    const controlDocTitle = useDocumentTitle()
    const location = useLocation();
    const navigate = useNavigate();
    const appContext = useContext(AppContext)
    const appData = useAppDataControl(appContext)
    const navMenuPreference = useUserStorage<NavigationBar>('menuPreferences')
    const [navBar, setNavBar] = useState<NavigationBar>(navMenuPreference?.data || { menuSelected: null, expanded: true, parentOpen: true, openResponsiveMenu: false })
    const [referencedDoc, setReferencedDoc] = useState<DocumentationProps | null>(null)
    const [logout, setLogout] = useState(false)

    const onPath = useCallback((item: NavItemDataProps) => {
        controlDocTitle(item.label)
        navigate(item.path || '/')
    }, [])

    const contextData = useMemo<DashboardContextType>(() => ({
        navBar,
        setNavBar,
        onPath,
        appData: appData.dataBase,
        updateAppData: appData.update,
        fullReload: appData.fullReload,
        offline: appData.offline,
        getCatalog: (key) => appData.dataBase.catalogApp?.[key] || [],
        referencedDoc,
        setReferencedDoc,
        logout: () => {
            appContext?.user.setData(null)
            setLogout(true)
        }
    }), [navBar, appData])

    useEffect(() => {
        if (!appContext?.user?.data?.token) {
            let newPath = location.pathname === '/' || logout ? '/' : `/?next=${location.pathname}`
            if (location.search) {
                newPath += `&${(location.search || '').replace('?', '')}`
            }
            navigate(newPath)
        }
    }, [appContext?.user, location])

    useEffect(() => {
        navMenuPreference.setData(navBar)
    }, [navBar])

    return (<ErrorBoundary>
        <DashboardContext.Provider value={contextData}>
            <SplashScreen dismiss={appData.fullLoad} maintenance={appData.offline} />
            {appData.fullLoad && children}
        </DashboardContext.Provider>
    </ErrorBoundary>
    )
}
